/* eslint-disable */
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import saveStoreDraft from "../../../utils/saveStoreDraft";
import { useTranslation as useUiTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import {
  Check,
  RefreshCw,
  Info,
  FileSpreadsheet,
  ShieldAlert,
  Database,
  Settings,
  X,
  Key,
  GripVertical,
  RotateCcw,
} from "lucide-react";
import apicache from "../../clearCach/clear";

const DEFAULT_COLUMNS = [
  {
    id: "timestamp",
    label: "التاريخ والوقت",
    field: "timestamp",
    enabled: true,
  },
  { id: "name", label: "اسم العميل", field: "name", enabled: true },
  { id: "orderId", label: "رقم الطلب", field: "orderId", enabled: true },
  { id: "product", label: "المنتج", field: "product", enabled: true },
  { id: "phone", label: "رقم الهاتف", field: "phone", enabled: true },
  { id: "state", label: "الولاية", field: "state", enabled: true },
  { id: "commune", label: "البلدية", field: "commune", enabled: true },
  { id: "address", label: "العنوان", field: "address", enabled: true },
  { id: "qty", label: "الكمية", field: "qty", enabled: true },
  { id: "note", label: "ملاحظة", field: "note", enabled: true },
  { id: "price", label: "السعر", field: "price", enabled: true },
  {
    id: "deleveryPrice",
    label: "سعر التوصيل",
    field: "deleveryPrice",
    enabled: true,
  },
  {
    id: "deleveryStatus",
    label: "حالة التوصيل",
    field: "deleveryStatus",
    enabled: true,
  },
  { id: "total", label: "الإجمالي", field: "total", enabled: true },
  { id: "options", label: "الخيارات", field: "options", enabled: true },
  {
    id: "deliveryType",
    label: "نوع التوصيل",
    field: "deliveryType",
    enabled: true,
  },
  { id: "sku", label: "SKU", field: "sku", enabled: true },
];

export default function ActivationGooglesheetV3({ close }) {
  const { t: uiT } = useUiTranslation();
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const products = useSelector((state) => state.ProductsReducer);
  const account = useSelector((state) => state.AccountReducer);
  const [draggedItem, setDraggedItem] = useState(null);
  const [columns, setColumns] = useState(DEFAULT_COLUMNS);
  const [hasLocalChanges, setHasLocalChanges] = useState(false);

  useEffect(() => {
    if (hasLocalChanges) return;

    const SKU_COLUMN = { id: "sku", label: "SKU", field: "sku", enabled: true };
    const existingColumns = store.googleSheetColumns || DEFAULT_COLUMNS;
    const hasSKU = existingColumns.some((col) => col.id === "sku");
    const updatedColumns = hasSKU
      ? existingColumns
      : [...existingColumns, SKU_COLUMN];

    const storeData = {
      ...store,
      googleSheetColumns: updatedColumns,
    };
    setColumns(storeData.googleSheetColumns);
  }, [store, hasLocalChanges]);

  const showAlert = (icon, title, text) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText: uiT("ship.ok"),
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `rgba(0,0,0,0.7)`,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  const handleDragStart = (e, index) => {
    setDraggedItem(index);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (draggedItem === null || draggedItem === index) return;

    const newColumns = [...columns];
    const draggedItemContent = newColumns[draggedItem];
    newColumns.splice(draggedItem, 1);
    newColumns.splice(index, 0, draggedItemContent);

    setDraggedItem(index);
    setHasLocalChanges(true);
    setColumns(newColumns);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
  };

  const toggleColumn = (index) => {
    const newColumns = [...columns];
    newColumns[index].enabled = !newColumns[index].enabled;
    setHasLocalChanges(true);
    setColumns(newColumns);
  };

  const resetToDefault = () => {
    setHasLocalChanges(true);
    setColumns(DEFAULT_COLUMNS);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isDeactivatingAll =
      !data.googleSheetId || data.googleSheetId.trim() === "";

    if (!isDeactivatingAll) {
      const hasNewMethod =
        data.googleSheetId &&
        data.googleSheetId.trim() !== "" &&
        data.googleSheetName &&
        data.googleSheetName.trim() !== "";

      if (!hasNewMethod) {
        await showAlert(
          "warning",
          "يرجى إدخال معلومات الربط",
          "يجب إدخال معرف Google Sheet واسم الصفحة"
        );
        return;
      }

      if (hasNewMethod) {
        const sheetIdPattern = /^[a-zA-Z0-9_-]+$/;
        if (!sheetIdPattern.test(data.googleSheetId)) {
          await showAlert(
            "warning",
            "صيغة معرف Google Sheet غير صحيحة",
            "يرجى التحقق من معرف الجدول والمحاولة مرة أخرى"
          );
          return;
        }
      }

      if (!data.frenchs && !data.arabics && !data.numberS) {
        await showAlert(
          "warning",
          "يرجى اختيار لغة",
          "يجب اختيار لغة لتلقي الولايات والبلديات"
        );
        return;
      }

      const enabledColumns = columns.filter((col) => col.enabled);
      if (enabledColumns.length === 0) {
        await showAlert(
          "warning",
          "يرجى اختيار عمود واحد على الأقل",
          "يجب تفعيل عمود واحد على الأقل لحفظ البيانات"
        );
        return;
      }
    }

    apicache(account, products);
    setLoading(true);
    try {
      if (isDeactivatingAll) {
        const updatedData = {
          ...data,
          googleSheetId: "",
          frenchs: false,
          arabics: false,
          numberS: false,
          googleSheetName: "",
          googleSheetColumns: DEFAULT_COLUMNS,
        };

        await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
        dispatch(applyStoreDraft(store, updatedData));
        setData(updatedData);
        setColumns(DEFAULT_COLUMNS);
        setHasLocalChanges(false);
        setLoading(false);
        await showAlert("success", "تم إلغاء تفعيل الخدمة بنجاح", "");
      } else {
        const useGoogleAPI = !!(
          data.googleSheetId && data.googleSheetId.trim() !== ""
        );

        const dataToSave = {
          ...data,
          useGoogleAPI,
          googleSheetColumns: columns,
        };

        await saveStoreDraft(doc(db, "store", data.id), store, dataToSave);
        dispatch(applyStoreDraft(store, dataToSave));
  setHasLocalChanges(false);
        setLoading(false);
        await showAlert("success", "تم حفظ الإعدادات بنجاح", "");
        close();
      }
    } catch (error) {
      setLoading(false);
      await showAlert(
        "error",
        isDeactivatingAll
          ? "حدث خطأ أثناء إلغاء تفعيل الخدمة"
          : "حدث خطأ أثناء حفظ الإعدادات",
        "يرجى المحاولة مرة أخرى"
      );
      console.error("Error saving Google Sheet settings:", error);
    }
  };

  const [data, setData] = useStoreFormDraft(store);

  const updateData = (updates) => {
    setHasLocalChanges(true);
    setData((prev) => ({ ...prev, ...updates }));
  };

  const handleFrench = () => {
    updateData({ frenchs: true, arabics: false, numberS: false });
  };

  const handleArabic = () => {
    updateData({ frenchs: false, arabics: true, numberS: false });
  };

  const handleNumber = () => {
    updateData({ frenchs: false, arabics: false, numberS: true });
  };

  const clearGoogleSheetId = () => {
    updateData({ googleSheetId: "", useGoogleAPI: false });
  };

  const extractSheetIdFromUrl = (url) => {
    const match = url.match(/\/d\/([a-zA-Z0-9-_]+)/);
    return match ? match[1] : null;
  };

  const handleSheetIdInput = (value) => {
    const extractedId = extractSheetIdFromUrl(value);
    if (extractedId) {
      updateData({ googleSheetId: extractedId });
    } else {
      updateData({ googleSheetId: value });
    }
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const isNewMethodActive =
    data.googleSheetId && data.googleSheetId.trim() !== "";
  const isServiceActive = isNewMethodActive;

  return (
    <div className="min-h-[400px] h-fit p-6" dir="rtl">
      <div className="mb-6">
        <h1 className="text-xl font-bold text-[#9e68ba] mb-2">
          {uiT("servicePageActivation.googleSheet.headerTitle")}
        </h1>
        <p className="text-gray-600">
          {uiT("servicePageActivation.googleSheet.headerDescription")}
        </p>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-[#fbf4ff] p-6 mb-6">
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-[#9e68ba] mb-4">
              {isServiceActive
                ? uiT("servicePageActivation.googleSheet.formTitleActive")
                : uiT("servicePageActivation.googleSheet.formTitleInactive")}
            </h3>
            <div className="mb-5 p-4 bg-green-50 rounded-lg border border-green-200">
              <div className="flex items-center mb-3">
                <Key size={18} className="text-green-600 ml-2" />
                <label className="block text-sm font-medium text-gray-700">
                  {uiT("ui.sheetIdMethod")}
                </label>
              </div>
              <div className="flex">
                <input
                  type="text"
                  placeholder={uiT("ui.sheetIdExample")}
                  value={data.googleSheetId || ""}
                  onChange={(e) => handleSheetIdInput(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg rounded-r-none focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-green-500"
                  style={{ direction: "ltr", textAlign: "left" }}
                />
                <button
                  type="button"
                  onClick={clearGoogleSheetId}
                  className="px-3 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg rounded-l-none border border-gray-300 border-l-0"
                >
                  <X size={18} />
                </button>
              </div>
              <div className="mt-2 text-sm text-gray-600">
                <p className="mb-1">
                  💡 <strong>{uiT("ui.sheetIdHow")}</strong>
                </p>
                <p className="text-xs mr-4">
                  {uiT("ui.sheetIdExtract")}{" "}
                  <code className="bg-white px-1 rounded">/d/</code> {uiT("ui.and")}{" "}
                  <code className="bg-white px-1 rounded">/edit</code>
                </p>
                <p className="text-xs mr-4 mt-2 text-orange-600">
                  ⚠️ <strong>{uiT("ui.important")}</strong> {uiT("ui.shareWithService")}
                </p>
              </div>
            </div>

            <div className="mt-4 mb-5">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {uiT("ui.sheetTabName")}
              </label>
              <input
                type="text"
                dir="rtl"
                style={{ direction: "rtl", textAlign: "right" }}
                placeholder={uiT("ui.sheetTabExample")}
                value={data.googleSheetName || ""}
                onChange={(e) => updateData({ googleSheetName: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-green-500"
              />
            </div>

            {(isServiceActive || data.googleSheetId) && (
              <>
                {/* Columns Order Section */}
                <div className="mb-5 p-4 bg-purple-50 rounded-lg border border-purple-200">
                  <div className="flex items-center justify-between mb-3">
                    <h4 className="text-sm font-medium text-gray-700 flex items-center">
                      <Database size={18} className="text-purple-600 ml-2" />
                      {uiT("ui.sheetColumnOrder")}
                    </h4>
                    <button
                      type="button"
                      onClick={resetToDefault}
                      className="flex items-center text-xs text-purple-600 hover:text-purple-800"
                    >
                      <RotateCcw size={14} className="ml-1" />
                      {uiT("ui.resetOrder")}
                    </button>
                  </div>
                  <p className="text-xs text-gray-600 mb-3">
                    {uiT("ui.columnOrderHelp")}
                  </p>
                  <div className="space-y-2 max-h-[400px] overflow-y-auto">
                    {columns.map((column, index) => (
                      <div
                        key={column.id}
                        draggable
                        onDragStart={(e) => handleDragStart(e, index)}
                        onDragOver={(e) => handleDragOver(e, index)}
                        onDragEnd={handleDragEnd}
                        className={`flex items-center p-3 bg-white rounded-lg border cursor-move transition-all ${
                          draggedItem === index
                            ? "opacity-50 border-purple-400"
                            : "border-gray-200 hover:border-purple-300 hover:shadow-sm"
                        }`}
                      >
                        <GripVertical
                          size={18}
                          className="text-gray-400 ml-2 flex-shrink-0"
                        />
                        <span className="flex-grow text-sm text-gray-700">
                          {uiT(`orders.sheetabndnConfig.columnsLabels.${column.id}`, { defaultValue: column.label })}
                        </span>
                        <div className="flex items-center">
                          <span className="text-xs text-gray-500 ml-3">
                            {index + 1}
                          </span>
                          <input
                            type="checkbox"
                            checked={column.enabled}
                            onChange={() => toggleColumn(index)}
                            onClick={(e) => e.stopPropagation()}
                            className="h-4 w-4 text-purple-600 rounded border-gray-300 focus:ring-purple-200"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500 mt-3">
                    {uiT("ui.enabledColumns")} {columns.filter((c) => c.enabled).length}{" "}
                    / {columns.length}
                  </p>
                </div>

                <div className="mb-5">
                  <label className="block text-sm font-medium text-gray-700 mb-3">
                    {uiT("servicePageActivation.googleSheet.languageLabel")}{" "}
                    <span className="text-red-500">*</span>
                  </label>
                  <div className="flex flex-wrap gap-4">
                    <div
                      className={`flex items-center px-4 py-2 rounded-lg border cursor-pointer transition-colors ${
                        data.frenchs
                          ? "bg-[#faf1ff] border-purple-300"
                          : "bg-white border-gray-300 hover:bg-gray-50"
                      }`}
                      onClick={handleFrench}
                    >
                      <input
                        type="checkbox"
                        checked={data.frenchs}
                        onChange={handleFrench}
                        className="h-4 w-4 text-[#9e68ba] rounded border-gray-300 focus:ring-purple-200 ml-2"
                      />
                      <span className="text-gray-700">{uiT("login.language.fr")}</span>
                    </div>

                    <div
                      className={`flex items-center px-4 py-2 rounded-lg border cursor-pointer transition-colors ${
                        data.arabics
                          ? "bg-[#faf1ff] border-purple-300"
                          : "bg-white border-gray-300 hover:bg-gray-50"
                      }`}
                      onClick={handleArabic}
                    >
                      <input
                        type="checkbox"
                        checked={data.arabics}
                        onChange={handleArabic}
                        className="h-4 w-4 text-[#9e68ba] rounded border-gray-300 focus:ring-purple-200 ml-2"
                      />
                      <span className="text-gray-700">{uiT("login.language.ar")}</span>
                    </div>

                    <div
                      className={`flex items-center px-4 py-2 rounded-lg border cursor-pointer transition-colors ${
                        data.numberS
                          ? "bg-[#faf1ff] border-purple-300"
                          : "bg-white border-gray-300 hover:bg-gray-50"
                      }`}
                      onClick={handleNumber}
                    >
                      <input
                        type="checkbox"
                        checked={data.numberS}
                        onChange={handleNumber}
                        className="h-4 w-4 text-[#9e68ba] rounded border-gray-300 focus:ring-purple-200 ml-2"
                      />
                      <span className="text-gray-700">
                        {uiT("servicePageActivation.googleSheet.languageNumbers")}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Tips Section */}
            <div className="bg-green-50 p-4 rounded-lg border border-green-100 mb-6">
              <h4 className="font-medium text-lg text-green-800 mb-2 flex items-center">
                <Info size={18} className="ml-2" />
                {uiT("servicePageActivation.googleSheet.tipsTitle")}
              </h4>
              <ul className="text-sm text-gray-700 space-y-2 mr-5 list-disc">
                <li className="flex items-start">
                  <FileSpreadsheet
                    size={16}
                    className="text-green-500 ml-2 mt-1 flex-shrink-0"
                  />
                  <span>
                    {uiT("servicePageActivation.googleSheet.tips.customTable")}
                  </span>
                </li>
                <li className="flex items-start">
                  <ShieldAlert
                    size={16}
                    className="text-green-500 ml-2 mt-1 flex-shrink-0"
                  />
                  <span>
                    {uiT("servicePageActivation.googleSheet.tips.permissions")}
                  </span>
                </li>
                <li className="flex items-start">
                  <Database
                    size={16}
                    className="text-green-500 ml-2 mt-1 flex-shrink-0"
                  />
                  <span>
                    {uiT("servicePageActivation.googleSheet.tips.formulas")}
                  </span>
                </li>
                <li className="flex items-start">
                  <Settings
                    size={16}
                    className="text-green-500 ml-2 mt-1 flex-shrink-0"
                  />
                  <span>
                    {uiT("servicePageActivation.googleSheet.tips.formatting")}
                  </span>
                </li>
              </ul>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className={`px-6 py-2.5 ${
                isServiceActive
                  ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                  : data.googleSheetId
                  ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                  : "bg-red-500 hover:bg-red-600"
              } text-white font-medium rounded-lg transition-colors flex items-center ${
                loading ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {data.googleSheetId
                    ? uiT("navbar.try.saving")
                    : uiT("servicePageActivation.upsell.button.disabling")}
                </>
              ) : (
                <>
                  <Check className="ml-2" size={18} />
                  {data.googleSheetId ? uiT("adduser.save_settings") : uiT("services.order_exporting.deactivate_btn")}
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
